/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'

import {
  Checkbox,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core'
import clsx from 'clsx'
import { get, isEmpty } from 'lodash'

import CustomTableHead from './CustomTableHead'
import useTableStyles from './css/tableStyles'

const CustomTable = ({
  className,
  rows,
  headCells,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  order,
  setOrder,
  orderBy,
  setOrderBy,
  selectedRows,
  setSelectedRows,
  rowsPerPageOptions,
  isDataLoading,
  checkTable,
  numberOfPages,
  onRowClick,
  hidePagination,
}) => {
  const classes = useTableStyles()

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(row => get(row, 'id') || '')
      setSelectedRows(newSelecteds)
      return
    }
    setSelectedRows([])
  }

  const handleClick = (event, id) => {
    const selectedIndex = selectedRows.indexOf(id)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, id)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1))
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      )
    }

    setSelectedRows(newSelected)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  // const alignment = (key = '', array = []) => {
  //   const res = array.find(item => key === get(item, 'id'))
  //   return get(res, 'numeric') ? 'right' : 'left'
  // }

  const hide = (key = '', array = []) => {
    const res = array.find(item => key === get(item, 'id'))
    return !!get(res, 'hide')
  }

  const isSelected = name => selectedRows.indexOf(name) !== -1

  const customCell = (key, content) => {
    switch (key) {
      default:
        return <Typography noWrap>{content || '-'}</Typography>
    }
  }

  return (
    <div className={clsx(classes.root, className)}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <CustomTableHead
              classes={classes}
              numSelected={selectedRows.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={get(rows, 'length') || 0}
              headCells={headCells}
              checkTable={checkTable}
            />
            <TableBody>
              {isDataLoading ? (
                <TableRow>
                  <TableCell>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : isEmpty(rows) ? (
                <TableRow>
                  <TableCell>
                    <Typography>No hay datos disponibles...</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                rows.map((row, index) => {
                  const isItemSelected = isSelected(get(row, 'id'))
                  const labelId = `enhanced-table-checkbox-${index}`

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={get(row, 'id')}
                      selected={isItemSelected}
                      onClick={() => onRowClick(row)}
                    >
                      {checkTable && (
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ 'aria-labelledby': labelId }}
                            onClick={event => handleClick(event, get(row, 'id'))}
                          />
                        </TableCell>
                      )}
                      {Object.keys(row).map((key, indexCell) => {
                        const keyCell = `table-cell-${indexCell}`
                        return (
                          !hide(key, headCells) && (
                            <TableCell align="center" key={keyCell}>
                              {customCell(key, row[key])}
                            </TableCell>
                          )
                        )
                      })}
                    </TableRow>
                  )
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {!hidePagination && (
          <TablePagination
            rowsPerPageOptions={!isEmpty(rowsPerPageOptions) ? rowsPerPageOptions : [10, 15, 25]}
            component="div"
            count={numberOfPages}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        )}
      </Paper>
    </div>
  )
}

CustomTable.propTypes = {
  className: PropTypes.string,
  headCells: PropTypes.array,
  rows: PropTypes.array,
  page: PropTypes.number,
  setPage: PropTypes.func,
  rowsPerPage: PropTypes.number,
  setRowsPerPage: PropTypes.func,
  order: PropTypes.string,
  setOrder: PropTypes.func,
  orderBy: PropTypes.string,
  setOrderBy: PropTypes.func,
  selectedRows: PropTypes.arrayOf(PropTypes.string),
  setSelectedRows: PropTypes.func,
  rowsPerPageOptions: PropTypes.array,
  isDataLoading: PropTypes.bool,
  checkTable: PropTypes.bool,
  numberOfPages: PropTypes.number,
  onRowClick: PropTypes.func,
  hidePagination: PropTypes.bool,
}

CustomTable.defaultProps = {
  className: '',
  rows: [],
  headCells: [],
  page: 0,
  setPage: () => {},
  rowsPerPage: 5,
  setRowsPerPage: () => {},
  order: 'asc',
  setOrder: () => {},
  orderBy: '',
  setOrderBy: () => {},
  selectedRows: [],
  setSelectedRows: () => {},
  rowsPerPageOptions: [],
  isDataLoading: false,
  checkTable: false,
  numberOfPages: 1,
  onRowClick: () => {},
  hidePagination: false,
}

export default CustomTable
